var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-dialog"},[_c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"width":"700","destroy-on-close":""},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('video',{staticClass:"video-full",attrs:{"src":_vm.videoUrl,"muted":"","autoplay":"","controls":true},domProps:{"muted":true}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }